import React from "react";
import "./Footer.scss";
import GLOBAL from "../../../global";
import {getCurrentYear} from "../../../utils/Utils";
import { useTenantFeatures } from "../../../features/tenantFeatures/useTenantFeature";

const socialMediaLinks = [
    {
        name: "Facebook",
        src: "/assets/images/facebook.png",
        href: "https://www.facebook.com/profile.php?id=61580305726912",
    },
    {
        name: "YouTube",
        src: "/assets/images/youtube.png",
        href: "https://www.youtube.com/@AtlasAthleteAI",
    },
    {
        name: "Instagram",
        src: "/assets/images/instagram.png",
        href: "https://www.instagram.com/atlasathlete.ai/",
    },
    {
        name: "LinkedIn",
        src: "/assets/images/linkedin.png",
        href: "https://www.linkedin.com/company/atlas-athlete-ai/",
    },
    {
        name: "TikTok",
        src: "/assets/images/tiktok.png",
        href: "https://www.tiktok.com/@atlasathlete.ai",
    },
];

const IntroSection = () => {
    const { isAthleteEnabled } = useTenantFeatures();
    const copyRight = (GLOBAL.TENANT_FEATURES?.find(f => f.Name === "CopyRight"));

    return (
        <section>
            <div
                className="footer-section"
                style={{
                    backgroundImage: `url('/assets/images/footer-background.png')`,
                    backgroundSize: "cover",
                    backgroundPosition: "bottom",
                    backgroundRepeat: "no-repeat",
                }}>
                <div>
                    <img
                        className={"footer-logo"}
                        src="/assets/images/logo.png"
                        alt="Atlas Athlete Logo"
                    />
                </div>

                <div className={"social-media-container"}>
                    {socialMediaLinks.map((social, index) => (
                        <a
                            key={index}
                            className="pointer"
                            href={social.href}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <img
                                width={59.42}
                                height={59.42}
                                src={social.src}
                                alt={`${social.name} Logo`}
                            />
                        </a>
                    ))}
                </div>

                <div className={"copyright-text-desktop"}>
                    &copy;{getCurrentYear()}&#x2024;&nbsp;
                    <a
                        rel="noopener noreferrer"
                        href={copyRight?.Url}
                        target="_blank">
                        {
                            <>
                                {copyRight?.Description}
                            </>
                        }
                    </a>
                </div>

            </div>
                <div className={"copyright-text-mobile-container"}>
                    <div className={"copyright-text-mobile"}>
                        &copy;{getCurrentYear()}&#x2024;&nbsp;
                        <a
                            rel="noopener noreferrer"
                            href={copyRight?.Url}
                            target="_blank">
                            {
                                <>
                                    {copyRight?.Description}
                                </>
                            }
                        </a>
                    </div>

                </div>

        </section>
    );
};

export default IntroSection;
